import { useCompanySettings } from '@Selectors/companySettings.selectors';
import { useGlobalization } from '@Translations';
import { Button, rem, useIsAdmin } from '@innovyze/stylovyze';
import { ACTIONS } from '@innovyze/stylovyze';
import React from 'react';
import GeneralSettingsTextIndicator from './components/GeneralSettingsTextIndicator';

const GeneralSettingsSecondary = () => {
	const { t } = useGlobalization();
	const { status } = useCompanySettings();
	const isAdmin = useIsAdmin();

	const action = React.useMemo(() => {
		const actions = ACTIONS(t);

		if (status === 'completed') return actions.saved;
		if (status === 'rejected') return actions.failed;
		if (status === 'pending') return actions.saving;

		return actions.clean;
	}, [status, t]);

	const { icon: Icon, iconColor, text, textColor } = action;

	if (!isAdmin) return <></>;

	return (
		<div style={{ display: 'flex', gap: rem(8), alignContent: 'center' }}>
			<GeneralSettingsTextIndicator
				icon={<Icon style={{ color: textColor }} />}
				label={text}
				variant="outlined"
				textColor={textColor}
				iconColor={iconColor}
			/>
			<Button
				key="saveButton"
				dataCy="saveButton"
				style={{ width: 'fit-content', marginLeft: 'auto' }}
				variant="contained"
				color="primary">
				{t('Save Settings')}
			</Button>
		</div>
	);
};

export default GeneralSettingsSecondary;
